import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HomeComponent } from './home.component';
import { ProjectComponent } from '../project/project.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { PanelListComponent } from '../panel-list/panel-list.component';
import { RecruiterMainComponent } from '../recruiters/recruiter.main.component';
import { ContributorsComponent } from '../contributors/contributors.component';
import { PerformanceTrackerComponent } from '../performance-tracker/performance-tracker.component';
import { SurveyBuilderResearchComponent } from '../survey-builder-research/survey-builder-research.component';
import { BiReportComponent } from '../bi-report/bi-report.component';
import { FunnelReportComponent } from '../funnel-report/funnel-report.component';
import { VisibilityControlComponent } from '../visibility-control/visibility-control.component';
import { DiaryTestComponent } from '../diary/diary-test/diary-test.component';
import { DiaryDayWiseComponent } from '../diary/diary-day-wise/diary-day-wise.component';
import { StudySurveyComponent } from '../study-survey/study-survey.component';
import { DiaryCenterWiseComponent } from '../diary/diary-center-wise/diary-center-wise.component';
import { CallRecordingComponent } from '../repository/call-recording/call-recording.component';
import { HomeRoutingModule } from './home-routing.module';
import { CreateRecruiterComponent } from '../recruiters/create/create.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AssignRecruiterComponent } from '../recruiters/assign-recruiter/assign-recruiter.component';
import { ChartModule } from 'angular-highcharts';
import { AssignStudyComponent } from '../recruiters/assign-study/assign-study.component';
import { CreateProjectComponent } from '../project/create-project/create-project.component';
import { CreateStudyComponent } from '../dashboard/create-study/create-study.component';
import { UpdateStudyComponent } from '../dashboard/update-study/update-study.component';
import { UpdateProjectComponent } from '../project/update-project/update-project.component';
import { BulkRecruiterComponent } from '../recruiters/bulk-recruiter/bulk-recruiter.component';
import { EditRecruiterComponent } from '../recruiters/edit/edit.component';
import { ProductTestingComponent } from './product-testing/product-testing.component';
import { PTEventComponent } from './pt-event/pt-event.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { StudySupersetComponent } from './study-superset/study-superset.component';
import { DashboardSuiteComponent } from './dashboard-suite/dashboard-suite.component';



@NgModule({
  declarations: [
    HomeComponent,
    ProjectComponent,
    DashboardComponent,
    CreateRecruiterComponent,
    PanelListComponent,
    RecruiterMainComponent,
    ContributorsComponent,
    PerformanceTrackerComponent,
    SurveyBuilderResearchComponent,
    BiReportComponent,
    FunnelReportComponent,
    VisibilityControlComponent,
    DiaryTestComponent,
    DiaryCenterWiseComponent,
    StudySurveyComponent,   
    CallRecordingComponent,
    DiaryDayWiseComponent,
    AssignRecruiterComponent,
    AssignStudyComponent,
    CreateProjectComponent,
    CreateStudyComponent,
    UpdateStudyComponent,
    UpdateProjectComponent,
    BulkRecruiterComponent,
    EditRecruiterComponent,
    ProductTestingComponent,
    PTEventComponent,
    StudySupersetComponent,
    DashboardSuiteComponent

    
  ],
  imports: [
    ChartModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    DragDropModule,
    InfiniteScrollModule,
    HomeRoutingModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      space: -14,
      maxPercent:100,
      outerStrokeGradient: false,
      outerStrokeWidth: 10,
      innerStrokeWidth: 10,
      outerStrokeColor: '#8c54ff',
      innerStrokeColor: '#f6f6f6',
      animateTitle: false,
      animationDuration: 800,
      showUnits: true,
      showBackground: true,
      clockwise: true,
      startFromZero: true,
      lazy: false,  
    }),
    GoogleChartsModule
  ]
})
export class HomeModule {}
